import { Constants } from "../../../../services/constants";
class TestDrivePopup
{

  constructor ( $sce )
  {
    'ngInject';

    Object.assign( this, { $sce } )

    this.videoUrl = this.$sce.trustAsResourceUrl( Constants.videos.testDriveUrl );
  }

  $onInit ()
  {
    $( 'body' ).css( 'overflow', 'hidden' );
  }

  $onDestroy ()
  {
    $( 'body' ).css( 'overflow', 'auto' );
  }

  close ()
  {
    this.onClose( { $event: { name: 'test-drive-popup' } } )
  }
}

export default TestDrivePopup;



// WEBPACK FOOTER //
// ./client/app/components/popups/dashboard/test-drive-popup/test-drive-popup.controller.js